import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=51e57477&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=51e57477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e57477",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e57477')) {
      api.createRecord('51e57477', component.options)
    } else {
      api.reload('51e57477', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=51e57477&scoped=true&", function () {
      api.rerender('51e57477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/teamMember.vue"
export default component.exports